import { Text } from "@tblabs/truffle";
import { Box } from "./Box";
import { SaleBasketItem } from "../../../Services/Basket/SaleBasketItem";


export class SaleSummaryBox extends Box
{
    constructor(item: SaleBasketItem)
    {
        super("product__summary", [
            new Box("product__summary-main product__summary-main--vertical", [
                new Box("product__summary-row", [
                    new Text(item.FinalPriceBeforeDiscount, v => v + "zł")
                        .Class("product__summary-price-original")
                        .Attribute("data-testid", "final-price-before-discount-value")
                        .VisibleWhen(item.FinalPriceAfterDiscount, v => v != item.FinalPriceBeforeDiscount.value, "flex"),
                ]),
                new Box("product__summary-row", [
                    new Box("product__summary-prices", [
                        new Text(item.FinalPriceAfterDiscount, v => v + " zł brutto")
                            .Class("product__summary-price")
                            .Attribute("data-testid", "final-price-after-discount-value"),
                    ]),
                ]),
            ]),
        ]);
    }
}
